module.exports = __webpack_public_path__ + "static/media/welcome-podcast.9b03f014.svg";